export const AFFINE_DRAG_HANDLE_WIDGET = 'affine-drag-handle-widget';
